export default "__VITE_ASSET__BIuCOwPm__"